import { CheckCircle2Icon, ChevronDownIcon, GitBranchIcon, Loader2Icon } from 'lucide-react'
import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

export interface ChatDelegationHeaderProps {
  targetLabel: string
  isComplete: boolean
  hasReport: boolean
  isExpanded: boolean
}

export const ChatDelegationHeader: React.FC<ChatDelegationHeaderProps> = ({
  targetLabel,
  isComplete,
  hasReport,
  isExpanded,
}): ReactNode => (
  <div className="chat-delegation-header flex items-center gap-3">
    <div className="flex size-8 flex-shrink-0 items-center justify-center rounded-md bg-violet-500/10">
      <GitBranchIcon className="size-4 text-violet-500" />
    </div>
    <div className="flex min-w-0 flex-1 flex-col gap-0.5">
      <span className="min-w-0 flex-1 truncate text-sm font-medium">
        Delegated to {targetLabel}
      </span>
      {hasReport && !isExpanded && (
        <span className="text-xs text-muted-foreground">Click to view content</span>
      )}
    </div>
    <div className="flex flex-shrink-0 items-center gap-2">
      {isComplete ? (
        <CheckCircle2Icon className="size-4 text-green-500" />
      ) : (
        <Loader2Icon className="size-4 animate-spin text-muted-foreground" />
      )}
      {hasReport && (
        <ChevronDownIcon
          className={cn(
            'size-4 text-muted-foreground transition-transform',
            isExpanded && 'rotate-180'
          )}
        />
      )}
    </div>
  </div>
)
